<template>
  <div class="cmp-custom-panel">
    <permissionsToolbar
      v-if="!selected_account_business_unit_id"
      :resources="resources"
      :selected-resource="selectedResource"
      :roles="roles"
      :can-edit="canEdit"
    />
    <div class="cmp-custom-panel-in">
      <div class="cmp-resources-cont" :style="{ maxHeight: `${maxHeight}px` }">
        <input-filter v-model="filterText" />
        <div v-for="r in sortedResources" :key="r.resource">
          <div v-if="r.serviceContainerFirst">{{ r.serviceContainerFirst }}</div>
          <a
            :class="{ 'cmp-active': r.resource == selectedResource, 'cmp-inner': r.serviceContainer }"
            @click="() => selectResource(r.resource)"
          >
            {{ r.content.description }}
          </a>
        </div>
      </div>
      <div class="cmp-resource" v-if="resourcePermissions && roles">
        <div class="cmp-header-permissions cmp-header-permissions--res" ref="stickyDivOne" :style="{ top: top + 'px' }">
          <ul>
            <li>
              <span>{{ resources[selectedResource].description }}</span>
            </li>
          </ul>
        </div>
        <editPermission
          :isBusinessUnit="true"
          :icon="'fa-cube'"
          :label="resources[selectedResource].description"
          :subtext="resources[selectedResource].notes"
          :actionLabels="resources[selectedResource].actions"
          :permissionKind="['bu', businessUnitId]"
          :businessUnitId="businessUnitId"
          :permissions="resourcePermissions.business_unit"
          @onEditPermission="onEditPermission"
          @onRemovePermission="onRemovePermission"
        />
      </div>
      <div class="cmp-permissions-cont-wrap" v-if="resourcePermissions">
        <div class="cmp-header-permissions" ref="stickyDiv" :style="{ top: top + 'px' }">
          <ul>
            <!-- Label dai ruoli -->
            <li v-for="(permissions, role_code) in resourcePermissions.roles" :key="'role-' + role_code">
              <span>{{ roles[role_code] ? roles[role_code].description[locale] : role_code }}</span>
            </li>

            <!-- Label dalle business units -->
            <li v-for="(permissions, acc_bu_id) in selectedAccountBusinessUnits" :key="'ubu-' + acc_bu_id">
              <span>{{ accountBusinessUnits[acc_bu_id] || acc_bu_id }}</span>
            </li>
          </ul>
        </div>
        <div class="cmp-permissions-cont">
          <editPermission
            v-for="(permissions, role_code) in resourcePermissions.roles"
            :key="role_code"
            :icon="'fa-id-badge'"
            :label="roles[role_code] ? roles[role_code].description[locale] : role_code"
            :actionLabels="resources[selectedResource].actions"
            :permissionKind="['role', role_code]"
            :businessUnitId="businessUnitId"
            :permissions="permissions"
            @onEditPermission="onEditPermission"
            @onRemovePermission="onRemovePermission"
          />
          <editPermission
            v-for="(permissions, acc_bu_id) in selectedAccountBusinessUnits"
            :key="acc_bu_id"
            :icon="'fa-user'"
            :label="accountBusinessUnits[acc_bu_id] || acc_bu_id"
            :actionLabels="resources[selectedResource].actions"
            :permissionKind="['ubu', acc_bu_id]"
            :businessUnitId="businessUnitId"
            :permissions="permissions"
            @onEditPermission="onEditPermission"
            @onRemovePermission="onRemovePermission"
          />
        </div>
      </div>
      <div v-else class="cmp-resource-empty">Seleziona una Risorsa</div>
    </div>
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import permissionsToolbar from './permissionsToolbar';
import editPermission from './editPermission';
import inputFilter from './inputFilter';

export default {
  name: 'listPermissions',
  components: {
    editPermission,
    permissionsToolbar,
    inputFilter,
  },
  props: ['selected_account_business_unit_id', 'canEdit'],
  data: () => ({
    resources: {},
    roles: {}, // eg. { 'INF' => {...} }
    resourcePermissions: null, // eg. { business_unit: [] }
    accountBusinessUnits: null, // eg. { 4: 'Alberto Bigoli', 8: 'Carla Deiani' }
    selectedResource: null,
    locale: window.locale,
    accountBusinessUnitsResults: [],
    filterText: '', // Used to text filtering, eg. 'Domi' to look for "Domicilio", "Domiciliare"
    top: 0,
  }),
  computed: {
    businessUnitId: () => window.config.business_unit.id,
    selectedAccountBusinessUnits() {
      return this.selected_account_business_unit_id ? this.resourcePermissions.account_business_units : {};
    },
    maxHeight() {
      return this.selectedResource ? 300 + Object.keys(this.resources[this.selectedResource].actions).length * 50 : 300;
    },
    sortedResources() {
      let serviceContainer = null;
      return Object.keys(this.resources)
        .sort((a, b) => {
          const aa = (a.split('::')[1] || '') + this.resources[a].description;
          const bb = (b.split('::')[1] || '') + this.resources[b].description;
          return aa.localeCompare(bb);
        })
        .map((k) => {
          let previous = serviceContainer;
          serviceContainer = k.match(/::/) ? k.replace(/^Service::/, '').split('::')[0] : null;
          return {
            resource: k,
            content: this.resources[k],
            serviceContainerFirst: serviceContainer && serviceContainer != previous ? serviceContainer : null,
            serviceContainer,
          };
        })
        .filter((r) => r.content.description.toLowerCase().includes(this.filterText.toLowerCase()));
    },
  },
  mounted() {
    this.getPermissions();
    this.updatePosition();
    window.addEventListener('scroll', this.updatePosition);
  },
  destroyed() {
    window.removeEventListener('scroll', this.updatePosition);
  },
  methods: {
    getPermissions() {
      Promise.all([
        apiConnector()
          .get(`/${window.locale}/permissions/resources?ubu_id=${this.selected_account_business_unit_id}`)
          .then(({ data }) => Promise.resolve(data)),
        apiConnector()
          .get(`/${window.locale}/permissions/roles?ubu_id=${this.selected_account_business_unit_id}`)
          .then(({ data }) => Promise.resolve(data)),
      ]).then(([resources, roles]) => {
        this.resources = resources;
        this.roles = roles;
        if (this.selected_account_business_unit_id) {
          apiConnector()
            .get(`/${window.locale}/users_business_units/autocomplete_user_firstname.json?ubu_id=${this.selected_account_business_unit_id}`)
            .then(({ data }) => {
              this.accountBusinessUnitsResults = data;
            });
        }
      });
    },
    updatePosition() {
      if (this.$refs.stickyDiv) {
        const distanceFromTop = -100;
        this.top = window.scrollY + distanceFromTop;
      }
      if (this.$refs.stickyDivOne) {
        const distanceFromTop = -100;
        this.top = window.scrollY + distanceFromTop;
      }
    },
    selectResource(resource) {
      this.selectedResource = resource;
      this.resourcePermissions = null;
      apiConnector()
        .get(`/${window.locale}/permissions/resources/${resource}?explain=true&ubu_id=${this.selected_account_business_unit_id}`)
        .then(({ data }) => {
          const ids = Object.keys(data.account_business_units).concat([this.selected_account_business_unit_id]); // eg. [4,8]
          return apiConnector()
            .get(`/${window.locale}/users_business_units/autocomplete_accounts_bu_names?ids=${ids.join(',')}`)
            .then((ubusRes) => ({
              resourcePermissions: data,
              accountBusinessUnits: {
                // eg. { 4: 'Alberto Bigoli', 8: 'Carla Deiani' }
                ...this.accountBusinessUnits,
                ...ubusRes.data,
              },
            }));
        })
        .then(({ resourcePermissions, accountBusinessUnits }) => {
          this.accountBusinessUnits = accountBusinessUnits;
          if (this.selected_account_business_unit_id) {
            const selectedUbuRes = this.accountBusinessUnitsResults.find((r) => r.id == this.selected_account_business_unit_id);
            this.resourcePermissions = {
              account_business_units: {
                [this.selected_account_business_unit_id]:
                  resourcePermissions.account_business_units[this.selected_account_business_unit_id],
              },
              business_unit: resourcePermissions.business_unit,
              roles: {
                [selectedUbuRes.data.role.code]: resourcePermissions.roles[selectedUbuRes.data.role.code],
              },
            };
            this.selectAccountBusinessUnit(this.selected_account_business_unit_id);
          } else {
            this.resourcePermissions = resourcePermissions;
          }
        });
    },
    onEditPermission(permissionAttributes) {
      apiConnector()
        .post(`/${window.locale}/permissions`, { permissions: [permissionAttributes] })
        .then(() => this.selectResource(permissionAttributes.resource))
        .catch(() => alert(i18nJS.permissions.editor.cannot_save));
    },
    onRemovePermission(savedPermission) {
      apiConnector()
        .delete(`/${window.locale}/permissions/${savedPermission.id}`)
        .then(() => this.selectResource(savedPermission.resource))
        .catch(() => alert(i18nJS.permissions.editor.cannot_delete));
    },
    selectAccountBusinessUnit(accountBuId) {
      if (this.resourcePermissions.account_business_units[accountBuId]) return;
      const selectedUbuRes = this.accountBusinessUnitsResults.find((r) => r.id == accountBuId);
      this.accountBusinessUnits = {
        ...this.accountBusinessUnits,
        [accountBuId]: `${selectedUbuRes.data.name} (${selectedUbuRes.data.role.name})`,
      };
      this.resourcePermissions.account_business_units = {
        ...this.resourcePermissions.account_business_units,
        [accountBuId]: {
          ...this.resourcePermissions.roles[selectedUbuRes.data.role.code],
          role: selectedUbuRes.data.role.code,
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.cmp-custom-panel {
  background: #f3f5f7;
  padding: 10px;
}
.cmp-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .cmp-title {
    font-size: 20px;
    font-weight: 200;
    margin: 15px 0 25px;
  }
}
.cmp-custom-panel-in {
  display: flex;
}
.cmp-resources-cont {
  overflow: auto;
  width: 250px;
  flex-shrink: 0;
  text-transform: uppercase;
  font-weight: 200;
  a {
    display: block;
    margin-bottom: 10px;
    &:hover {
      color: #ccc;
    }
  }
  .cmp-active {
    font-weight: 600;
  }
  .cmp-inner {
    margin-left: 25px;
  }
}
.cmp-resource {
  background: #fff;
  width: 300px;
  flex-shrink: 0;
  position: relative;
  overflow-y: hidden;

  @media screen and (min-width: 1280px) {
    width: 400px;
  }
}
.cmp-resource-empty {
  padding: 20px;
  background: #fff;
  flex-grow: 1;
}
.cmp-permissions-cont-wrap {
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
  background: #fff;
}
.cmp-header-permissions {
  position: absolute;
  width: 100%;
  ul {
    display: flex;
    flex-grow: 1;
    width: 100%;
    margin: 0;
    li {
      width: 120px;
      padding: 20px 0 5px 0;
      background: #fff;
      flex-shrink: 0;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      min-height: 95px;

      span {
        padding: 0 5px;
        margin-top: 10px;
        display: block;
        color: var(--adv-primary-color);
      }
    }
  }
  &--res {
    ul {
      li {
        width: 100%;
      }
    }
  }
}
.cmp-permissions-cont {
  background: #fff;
  display: flex;
  flex-grow: 1;
}
</style>
